import React from 'react'

function HeaderAbout({title, image, children}) {
  return (
    <section className='about-header'>
        <div className="about-header__container">
            <div className="about-header-container-bg">
                <img src={image} alt="about-header background" />
            </div>
            <div className="about-header__content">
                <h2>{title}</h2>
                <p>{children}</p>
            </div>
        </div>
    </section>
  )
}

export default HeaderAbout